import React, { Component } from 'react'
import './styles.css'
import PropTypes from 'prop-types'

class TableHead extends Component {
  render () {
    const style = {}
    if (this.props.hasOwnProperty('width')) {
      style.width = this.props.width + 'px'
    }
    return (
      <div className="TableHead" style={style}>
        {this.props.children}
      </div>
    )
  }
}

TableHead.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.any
}
export default TableHead
